import Close from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Close'
import PortalLearningPath from '@classes/LearningPath'
import BlockedUnlocked from '@components/LPCard/SPPanel/BlockedUnlocked'
import Completed from '@components/LPCard/SPPanel/Completed'
import JoinOption from '@components/LPCard/SPPanel/JoinOption'
import Locked from '@components/LPCard/SPPanel/Locked'
import PendingFeedback from '@components/LPCard/SPPanel/PendingFeedback'
import Unlocked from '@components/LPCard/SPPanel/Unlocked'
import UnlockedMultiple from '@components/LPCard/SPPanel/UnlockedMultiple'
import { LP_STATUS } from '@utils/constants/learningPath'
import React, { useState } from 'react'
import { Transition } from 'react-transition-group'
import { ITransitionState } from './interface'
import { CloseContainer, FadeIn } from './style'

interface IPSliderContent {
  duration?: number
  isOpen: boolean
  onCloseHandler: (val?: boolean) => void
  Path: PortalLearningPath
  MainPath: PortalLearningPath
}

const SliderContent: React.FC<IPSliderContent> = ({ duration = 300, onCloseHandler, isOpen, Path, MainPath }) => {
  const [BookableLCS] = useState(Path.BookableLCS)
  const [Unit] = useState(Path.NextSessionUnit)

  return (
    <Transition in={isOpen} timeout={duration}>
      {(state: ITransitionState) => (
        <FadeIn className="fade-in" state={state} duration={duration}>
          <CloseContainer Unit={Unit} status={Unit?.Status} onClick={() => onCloseHandler(false)}>
            <Close />
          </CloseContainer>
          {(() => {
            const isBooked = Unit?.IsBooked && Number(Unit?.Session?.lesson?.UnitId || 0) === Unit.Id
            switch (Unit?.Status) {
              case LP_STATUS.LOCKED:
                return <Locked Unit={Unit} />
              case LP_STATUS.COMPLETE:
                return Unit?.IsBooked && Unit?.IsBookedFromSameLP ? (
                  <JoinOption Unit={Unit} />
                ) : !Unit.Session?.Materials?.length && !Unit.UnlimitedLCS ? (
                  <PendingFeedback Unit={Unit} />
                ) : Unit?.IsBooked && Unit.UnlimitedLCS ? (
                  <BlockedUnlocked ActiveUnits={BookableLCS} Unit={Unit} />
                ) : (
                  <Completed Path={Path} Unit={Unit} MainPath={MainPath} />
                )
              case LP_STATUS.UNLOCKED:
                return isBooked ? (
                  <JoinOption Unit={Unit} Path={Path} />
                ) : Unit?.IsBooked ? (
                  <BlockedUnlocked ActiveUnits={BookableLCS} Unit={Unit} />
                ) : BookableLCS.length > 1 ? (
                  <UnlockedMultiple ActiveUnits={BookableLCS} Path={Path} />
                ) : Path?.UnlimitedCoaching ? (
                  <Completed Path={Path} Unit={Unit} MainPath={MainPath} />
                ) : (
                  <Unlocked Unit={Unit} />
                )
              default:
                return <Completed Path={Path} Unit={Unit} MainPath={MainPath} />
            }
          })()}
        </FadeIn>
      )}
    </Transition>
  )
}

export default SliderContent
